<nz-layout>
  <bemum-header></bemum-header>

  <nz-content>
    <router-outlet></router-outlet>
  </nz-content>
</nz-layout>
